import { Skeleton } from '@/shared/ui/Skeleton';
import styles from './content-route-fallback.module.css';

export function ContentRouteFallback() {
  return (
    <div className={styles.container} data-testid="content-route-fallback">
      <Skeleton width="40%" height={32} />
      <Skeleton width="65%" height={20} />
      <div className={styles.cards}>
        <Skeleton width="100%" height={160} />
        <Skeleton width="100%" height={160} />
      </div>
    </div>
  );
}
